import React from "react";
import Navbar from "./Navbar";

function Header() {
    return (
        <header>
            <div className="container">
                <h1>Dilruba Hub</h1>
                <Navbar />
            </div>
        </header>
    );
}

export default Header;
